module.exports = __webpack_public_path__ + "img/doctor-refer.f471b626.jpg";